<template>
  <div class="search_bar">
    <button class="back_btn ab" @click="goBack()">
      <span class="btn_image"><img :src="require('@/assets/images/fanclub/arrow_green.png')" alt=""></span>
      戻る
    </button>
    <!-- <button class="back_btn ab" @click="$router.go(-1)">
      <span class="btn_image"><img :src="require('@/assets/images/calendar/prev.png')" alt=""></span>
      コラムTOP
    </button> -->
    <!-- <Home class="home" @click="backToTop()" /> -->
  </div>
</template>

<script>
import SearchInput from '@/components/fanClub/column/SearchInput';
// import Home from '@/components/fanClub/column/parts/Home';

export default {
  components: {
    // Home,
    SearchInput
  },
  methods: {
    backToTop() {
      this.$store.commit('setArticleResultType', false);
    },
    goBack() {
      this.backToTop();
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="css" scoped>
.search_bar {
  /* align-items: flex-end; */
  display: flex;
  height: 70px;
  position: fixed;
  width: 100%;
  background-color: #fff;
  top: 0;
}
.back_btn {
  align-items: center;
  border: none;
  background: transparent;
  display: flex;
  font-size: 16px;
  padding: 0;
  color: #1DB9B9;
}
.btn_image {
  margin-right: 4px;
  width: 18px;
  height: 18px;
}
.home {
  bottom: 0;
  left: 0;
  margin: auto;
  right: 0;
  position: absolute;
  /* margin-left: 8px; */
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/NavigationBar.vue